TrelloModel = require 'models/internal/trello-model'

module.exports = class CustomEmoji extends TrelloModel
  typeName: 'CustomEmoji'



// WEBPACK FOOTER //
// ./app/scripts/models/custom-emoji.coffee